// Get visible expenses
export default (works, filters) =>{
  
  return works.filter( (work) =>{
    const webMatch = filters.fields[0] ? work.fields[0] : false; 
    const designMatch = filters.fields[1] ? work.fields[1] : false; 
    const mobMatch = filters.fields[2] ? work.fields[2] : false; 
    const identityMatch = filters.fields[3] ? work.fields[3] : false; 

    return webMatch || designMatch || mobMatch || identityMatch
  })

};


// WEBPACK FOOTER //
// ./src/selectors/works.js